<template>
  <div id="join_module">
    <div>
      <img src="../../../../static/img/join/banner_02.jpg" width="100%" alt />
    </div>
    <div class="join_jobs">
      <div class="job_title">诚聘英才</div>
      <el-table :data="tableData" class="jb_tab">
        <el-table-column prop="jobName" label="职位名称"></el-table-column>
        <el-table-column prop="jobNum" label="人数"></el-table-column>
        <el-table-column prop="address" label="地点"></el-table-column>
        <el-table-column prop="addTime" label="发布时间"></el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <el-button
              class="job_info_btn"
              round
              @click="viewJobInfo(scope.row.jobId,scope.row.addTime)"
            >查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :page-size="pageSize"
          :total="totalpage"
          background
          layout=" prev, pager, next"
          @current-change="turnPage"
        />
      </div>
    </div>
    <div class="welfare_module">
      <join-welfare></join-welfare>
    </div>
  </div>
</template>
<script>
import { jobList } from '@/api/frontApi/join';
import joinWelfare from './welfare';
export default {
  data() {
    return {
      tableData: [],
      jobArray: [],
      jobsFiles: [
        { name: '嵌入式开发工程师', jobId: '1' },
        { name: '嵌入式软硬件工程师', jobId: '2' },
        { name: '电控开发工程师', jobId: '3' },
        { name: '知识产权管理专员', jobId: '4' }
      ],
      jobList: [
        { content: '', skills: [], need: [] },
        { content: '', skills: [], need: [] }
      ],
      pageSize: 8,
      totalpage: 1,
      pageNo: 1
    };
  },
  components: {
    joinWelfare
  },
  created() {
    this.getJobList();
  },
  methods: {
    autoSpan(param) {
      let finalSpan = 0;
      let caseSpan = param.length;
      switch (caseSpan) {
        case 5:
          finalSpan = 5;
          break;
        case 2:
          finalSpan = 3;
          break;
        default:
          finalSpan = 4;
          break;
      }
      return finalSpan;
    },
    getJobList() {
      jobList({ pageNo: this.pageNo, pageSize: 200 }).then(res => {
        res.data.list.forEach(item => {
          item.address = '洛阳';
        });
        this.jobArray = res.data.list;
        this.totalpage = res.data.pageTotal;
        this.tableData = this.jobArray.slice(0, this.pageSize);
      });
    },
    closeJob(jobObj) {
      jobObj.isShow = false;
    },
    viewJobInfo(jobId, tiem) {
      this.$router.push({
        name: 'jobInfo',
        params: {
          jobId: jobId,
          proTime: tiem
        }
      });
    },
    turnPage(val) {
      this.pageNo = val;
      this.tableData = this.jobArray.slice(
        (this.pageNo - 1) * this.pageSize,
        this.pageNo * this.pageSize
      );
    }
  }
};
</script>
<style lang="stylus" scoped>
#join_module {
  width: 100%;
  min-height: 600px;
}

.welfare_module {
  width: 100%;
}

.welfare_address {
  width: 75%;
  margin: 10px auto 0;
  max-height: 380px;

  .welfare_address_left {
    background-color: #D2EDF8;
    max-height: 380px;
    width: 99%;

    .left_cup {
      padding: 10px 15px;
    }
  }
}

.job_title {
  font-size: 24px;
  height: 45px;
  line-height: 45px;
  font-weight: 800;
}

.job_treat_cup {
  width: 100%;

  ul {
    overflow: hidden;
  }

  .job_treat {
    background-color: #139CAC;
    color: #FFFFFF;
    padding: 6px 8px;
    font-size: 18px;
  }
}

.job_text {
  font-size: 16px;
  height: 25px;
  line-height: 25px;
}

.join_jobs {
  width: 75%;
  margin: 0 auto;
  padding: 20px;

  .jb_tab {
  }
}

img {
  vertical-align: middle;
}

.join_text {
  text-indent: 2em;
}

.jobActive {
  background-color: #139CAC;
  color: #fff;
  border-bottom: 1px solid #139CAC;
}

.pagination {
  margin-top: 15px;
}

.job_info_btn {
  border: 1px solid #139CAC;
  color: #139CAC;
}

.job_title {
  font-size: 24px;
  height: 25px;
  line-height: 25px;
  font-weight: 800;
  border-left: 5px solid #139CAC;
  padding-left: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/joinus/join.vue